<template>
  <div class="reset-pwd">
    <ValidationObserver v-if="step === 1" tag="form" ref="resetPwd">
      <message-box :globalConfig='globalConfig' :boxHeight="337" :showicon="false" key="step1" @off="close">
        <template v-slot:title>
          <span class="reset_title">重置密码</span>
        </template>
        <template v-slot:body>
          <div class="body__item" style="margin-bottom:16px">
            <validation-provider rules="required" v-slot="{ errors }" name="手机号">
              <input class="body__item__input" placeholder="手机号" type="text" v-model="mobile" />
              <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="body__item" style="margin-bottom:12px">
            <validation-provider rules="required" v-slot="{ errors }" name="验证码">
              <input
                type="text"
                class="body__item__input code_input"
                v-model="verifyCode"
                placeholder="验证码"
                autocomplete="off"
              />
              <span class="code tip">{{ errors[0] }}</span>
            </validation-provider>
            <sendCode :globalConfig='globalConfig' :mobile="mobile" :closeTimer="closeTimer" :type="4" :captcha.sync="captcha"/>
          </div>
          <div class="body__item" v-show="captcha"> <div id="captcha"/></div>
          <p class="body__sign">
            *忘记或没有绑定手机号码，请拨打客服电话 10108899
          </p>
        </template>
        <template v-slot:footer>
          <Button :globalConfig='globalConfig' @handleClick="handleNext" text="下一步" buttonType="login" />
          <p class="backToSignin" @click="handleGoLogin" :style="setColor">返回登录</p>
        </template>
      </message-box>
    </ValidationObserver>
    <ValidationObserver v-if="step === 2" tag="form" ref="affirmResetPwd">
      <message-box :globalConfig='globalConfig' :showicon="false" key="step2" @off="close" :boxHeight="254">
        <template v-slot:title>
          <span class="reset_title">设置密码</span>
        </template>
        <template v-slot:body>
          <div class="body__item">
            <validation-provider rules="required|password" v-slot="{ errors }" name="密码">
              <PasswordInput
                v-model="password"
                onkeydown="if(event.keyCode==13){event.keyCode=0;event.returnValue=false;}"
                placeholder="请输入密码"
                @enter="handleReset"
                newPassword
                @input.prevent
              />
              <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <p class="body__tips">
            *支持8-16位，同时包含字母大小写与数字
          </p>
        </template>
        <template v-slot:footer>
          <Button :globalConfig='globalConfig' @handleClick="handleReset" text="重置密码" buttonType="login" />
        </template>
      </message-box>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import MessageBox from './MessageBoxnew.vue';
import SendCode from './SendCodeNew.vue';
import Button from './LoginButton.vue';
import PasswordInput from './PasswordInput.vue';
import { mapState} from 'vuex'

extend('required', {
  ...required,
  message: '{_field_}不能为空',
});
extend('password', {
  validate: (value) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/.test(value),
  params: ['password'],
  message: '{_field_}支持8-16位，并同时包含字母大小写与数字',
});

export default {
  data() {
    return {
      step: 1, // 1 重置密码获取验证码界面 2 确认重置密码界面
      closeTimer: true,
      tag: '',
      captcha: false,
      mobile: '',
      password: '',
      verifyCode: '',
    };
  },
  computed:{
     ...mapState({
        globalConfig: state => state.router.globalConfig,
    }),
    setColor(){
      return{
        'color':this.globalConfig.vice,
      }
    }
  },
  components: {
    MessageBox,
    SendCode,
    Button,
    ValidationProvider,
    ValidationObserver,
    PasswordInput,
  },
  created() {
    window.TAL_UC.configNVC({
      renderToEle: '#captcha',
      isH5: false,
      onloadCallback() {},
      failCallback() {},
    });
  },

  methods: {
    async handleReset() {
      const isValid = await this.$refs.affirmResetPwd.validate();
      if (isValid) {
        try {
          this.setPassword();
        } catch (e) {
          // console.log(e);
        }
      }
    },
    async handleNext() {
      const isValid = await this.$refs.resetPwd.validate();
      if (isValid) {
        this.checkPhone();
      }
    },
    close() {
      this.step = 1;
      this.$emit('closeResetMessageBox');
    },
    listenMobile(mobile) {
      this.mobile = mobile;
    },
    handleGoLogin() {
      this.$emit('closeResetMessageBox', true);
    },
    checkPhone() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      _this.captcha = false;
      const param = {
        data: {
          type: 4,
          phone_code: '86',
          device_id: window.deviceId,
          phone: _this.mobile,
          vcode: _this.verifyCode,
        },
        success: (res) => {
          if (res.errcode === 11021) {
            const param2 = {
              slideCallback: 'checkPhone',
              slideParams: param,
              failCallback(err) {
                _this.captcha = false;
                this.$message.showMessage({ info: `${err.errmsg}` });
              },
            };
            _this.captcha = true;
            window.TAL_UC.showSlide(param2);
          } else if (Number(res.errcode) === 0) {
            _this.tag = res.data.tag;
            _this.step = 2;
          } else {
            this.$message.showMessage({ info: `${res.errmsg}` });
          }
        },
        fail: (err) => this.$message.showMessage({ info: `${err.errmsg}` }),
      };
      window.TAL_UC.checkPhone(param);
    },
    setPassword() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      _this.captcha = false;
      const param = {
        data: {
          type: 1,
          tag: _this.tag,
          phone: _this.mobile,
          phone_code: '86',
          password: _this.password,
        },
        success: (res) => {
          if (res.errcode === 11021) {
            const param2 = {
              slideCallback: 'setPassword',
              slideParams: param,
              failCallback(err) {
                _this.captcha = false;
                this.$message.showMessage({ info: err.errmsg });
              },
            };
            _this.captcha = true;
            window.TAL_UC.showSlide(param2);
          } else if (res.errcode === 0) {
            this.$message.showMessage({ info: '新密码设置成功' });
            this.$emit('closeResetMessageBox', false);
          } else {
            this.$message.showMessage({ info: res.errmsg });
          }
        },
        fail: (err) => {
          this.$message.showMessage({ info: err.errmsg });
        },
      };
      window.TAL_UC.setPassword(param);
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/styles/captcha.less";
.body__tips {
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:17px;
  text-align:center;
  margin-block-end: 0px;
}
.body__affirmPwd {
  margin-top: 50px !important;
}
.body__item {
  position: relative;
  text-align: center;
  z-index: 1;
  display:flex;
  justify-content:space-between;
  margin: 0 32px 16px;
  &>span {
    width: 100%;
    text-align: left;
  }
  &:first-child {
    margin-top: 30px;
    margin-bottom: 16px;
  }
  .lab {
    display: inline-block;
    width: 100px;
    text-align: right;
    font-size: 19px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(9, 2, 3, 1);
  }

  .body__item__input {
    width: 345px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    border: 1px solid rgba(192, 192, 192, 1);
    outline: none;
    padding: 19px;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 14px;
  }
  .body__item__input.code_input {
    width: 197px;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px rgba(255, 253, 246, 0) inset;
    -webkit-text-fill-color: #7e7e7e;
  }
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 100px rgba(255, 253, 246, 1) inset;
    -webkit-text-fill-color: #7e7e7e;
  }
  /deep/input::-webkit-input-placeholder {
    color: #7e7e7e;
  }
  /deep/input {
    color: #7e7e7e;
    padding: 0 13px;
    width: 264px;
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(190, 190, 190, 1);
    border-radius: 6px;
    outline: none;
    &:focus {
      background: rgba(255, 253, 246, 1);
    }
  }
  .input {
    width: 264px;
    height: 32px;
    display: inline-block;
    .sex {
      cursor: pointer;
      text-align: center;
      display: inline-block;
      width: 62px;
      height: 32px;
      background: rgba(230, 230, 230, 1);
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.24);
      border-radius: 6px;
      position: relative;
      margin-left: 35px;
      margin-right: 16px;
      padding-left: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      line-height: 32px;
      .icon {
        position: absolute;
        top: -6px;
        left: -22px;
        width: 44px;
        height: 44px;
        border-radius: 22px;
        background: rgba(230, 230, 230, 1);
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.24);
        img {
          position: absolute;
          margin: auto;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
      &:hover {
        transform: scale(1.1);
      }
      &.active {
        transform: scale(1.1);
        background: rgba(255, 253, 246, 1);
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.25);
        border: none;
        .icon {
          background: rgba(255, 253, 246, 1);
        }
      }
    }
    /deep/.el-icon-arrow-up {
      line-height: 32px;
      &::before {
        content: "\e78f";
      }
    }
  }
  /deep/.el-input__inner {
    height: 32px;
    border: 1px solid rgba(192, 192, 192, 1);
  }
}
.body__sign {
  text-align: center;
  height:17px;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:17px;
  margin-block-end: 0px
}
.tip {
  // position: absolute;
  // bottom: 21px;
  width: 100%;
  text-align: center;
  margin: 4px 0px -12px;
  display: block;

  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(233,43,51,1);
  line-height:17px;
}
.code.tip {
  margin-left: 66px;
  margin-right: -66px;
}
.reset_title {
  width: 100px;
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 33px;
}
.backToSignin {
  width:56px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(104,149,60,1);
  line-height:20px;
  cursor:pointer;
}
</style>
